export enum ApplicationType {
  LEASE_BUYOUT = 'LEASE_BUYOUT',
  PURCHASE = 'PURCHASE',
  RE_F_AND_I = 'RE_F_AND_I',
  REFINANCE = 'REFINANCE',
}
